module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-loader-spinner/index.js
// module id = 972
// module chunks = 0